"use strict";

var _interopRequireDefault = require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.map.js");
require("core-js/modules/es.array.push.js");
require("core-js/modules/es.iterator.constructor.js");
require("core-js/modules/es.iterator.map.js");
require("core-js/modules/es.number.to-fixed.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.string.replace.js");
var _interopRequireWildcard2 = _interopRequireDefault(require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/interopRequireWildcard.js"));
var _regenerator2 = _interopRequireDefault(require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/regenerator.js"));
var _asyncToGenerator2 = _interopRequireDefault(require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _lodash = _interopRequireDefault(require("lodash"));
var _log = require("@/utils/log");
var _permission = _interopRequireDefault(require("@/utils/permission"));
var _cookie = require("@/utils/cookie");
var _hike = require("@/api/hike");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// import { writeGaEvent } from '@/utils/ga'
// import { userEvent } from '@/lifehikes-init-data'
var _default = exports.default = {
  name: 'HikeActivityReport',
  data: function data() {
    return {
      hikeId: '',
      hikeTitle: '',
      loading: false,
      downloadLoading: false,
      reportData: null,
      reportHeader: null,
      column: null,
      header: null,
      autoWidth: 100,
      totalPercentOfAttendance: 0,
      totalPercentOfAttendancePerStage: [],
      avgOfCompletionRate: 0
    };
  },
  created: function created() {
    var _this = this;
    return (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee() {
      var id;
      return (0, _regenerator2.default)().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            id = typeof _this.$route.params.id === 'undefined' ? '' : _this.$route.params.id;
            _this.hikeTitle = _this.$route.query.title ? _this.$route.query.title : '-';
            _this.hikeId = id;
            _this.getReport(id);
          case 1:
            return _context.a(2);
        }
      }, _callee);
    }))();
  },
  methods: {
    checkPermission: _permission.default,
    getReport: function getReport(id) {
      var _this2 = this;
      var token = (0, _cookie.getCookie)('ACCESS_TOKEN');
      this.loading = true;
      (0, _hike.getHikeActivityReport)(token, id).then(function (response) {
        var resp = response.data;
        _this2.reportData = resp.reportdata;
        //this.reportHeader = resp.tableHeader

        if (_this2.reportData.length > 0) {
          _this2.header = _this2.reportData[0].activityStatus;
        }
        var attendancefigures = _this2.getPercentOfAttendance(resp.tableHeader, resp.reportdata);
        _this2.avgOfCompletionRate = _this2.getAverageCompleteRate(resp.reportdata);
        _this2.totalPercentOfAttendance = attendancefigures.hikePercentage;
        _this2.totalPercentOfAttendancePerStage = attendancefigures.stagePercentage;
        _this2.loading = false;
      }).catch(function (error) {
        (0, _log.showDebugLog)('hike-activity-error', error);
        _this2.loading = false;
        (0, _log.displayPopupMessage)(error, 'error');
      });
    },
    backToHike: function backToHike() {
      var id = typeof this.$route.params.id === 'undefined' ? '' : this.$route.params.id;
      this.$router.push("/hike/index");
    },
    handleDownload: function handleDownload() {
      var _this3 = this;
      this.downloadLoading = true;
      Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/vendor/Export2Excel'));
      }).then(function (excel) {
        var xdata = _this3.buildExcelData();
        excel.export_json_to_excel({
          header: xdata.header,
          data: xdata.data,
          filename: 'Hike Activity Report'
        });

        //excel.export_table_to_excel('dataTable')

        _this3.downloadLoading = false;
      });
    },
    formatJson: function formatJson(filterVal, jsonData) {
      return jsonData.map(function (v) {
        return filterVal.map(function (j) {
          if (j === 'timestamp') {
            return parseTime(v[j]);
          } else {
            return v[j];
          }
        });
      });
    },
    buildExcelData: function buildExcelData() {
      var excelData = [];
      var excelHeader = [];
      // build first 4 header rows
      for (var i = 0; i < 4; i++) {
        var row = [];
        row.push(" ");
        row.push(" ");
        row.push(" ");
        row.push(" ");
        row.push(" ");
        row.push(" ");
        if (i == 0) row.push('Stage');
        if (i == 1) row.push('Activity Type');
        if (i == 2) row.push('Activity Title');
        if (i == 3) row.push('Activity Steps');
        for (var j = 0; j < this.header.length; j++) {
          if (i == 0) row.push(this.header[j].stage + ' ');
          if (i == 1) row.push(this.header[j].activityType + ' ');
          if (i == 2) row.push(this.header[j].activityTitle + ' ');
          if (i == 3) row.push(this.header[j].activityStepValue + ' ');
        }
        if (i == 0) {
          excelHeader = row;
        } else {
          excelData.push(row);
        }
      }

      // build data row
      for (var x = -1; x < this.reportData.length; x++) {
        var row = [];
        // data row header
        if (x == -1) {
          row.push("Given name");
          row.push("Surname");
          row.push("Email");
          row.push("Trail Selection");
          row.push("% of selected stage complete");
          row.push("Total Steps");
          row.push("-");
          for (var z = 0; z < this.header.length; z++) {
            row.push('-');
          }
        } else {
          row.push(this.reportData[x].givenName);
          row.push(this.reportData[x].familyName);
          row.push(this.reportData[x].email);
          row.push(this.reportData[x].trail);
          row.push(this.reportData[x].completionPercentage);
          row.push(this.reportData[x].userTotalSteps);
          row.push("-");
          for (var z = 0; z < this.header.length; z++) {
            var isDone = this.reportData[x].activityStatus[z].isDone;
            row.push(isDone);
          }
        }
        excelData.push(row);
      }
      return {
        data: excelData,
        header: excelHeader
      };
    },
    getPercentOfAttendance: function getPercentOfAttendance(header, data) {
      var percentOfAttendanceOfHike = 0;
      var percentOfAttendanceOfStages = [];
      var checkinstageId = [];
      var noOfParticipant = data.length;
      var totalCheckinStage = 0;
      var totalUserCheckin = 0;
      var totalCompletionRate = 0;
      for (var i = 0; i < header.length; i++) {
        if (header[i].stageType === 'checkin') {
          checkinstageId.push(header[i].stageId);
          totalCheckinStage += 1;
        }
      }
      for (var h = 0; h < checkinstageId.length; h++) {
        var totalUserCheckinStage = 0;
        for (var i = 0; i < data.length; i++) {
          for (var j = 0; j < data[i].activityStatus.length; j++) {
            if (data[i].activityStatus[j].stageType == 'checkin' && data[i].activityStatus[j].isDone == 'YES' && data[i].activityStatus[j].stageId == checkinstageId[h]) {
              totalUserCheckinStage += 1;
            }
          }
        }
        totalUserCheckin += totalUserCheckinStage;
        percentOfAttendanceOfStages.push((totalUserCheckinStage / noOfParticipant * 100).toFixed(2));
      }
      percentOfAttendanceOfHike = (totalUserCheckin / (totalCheckinStage * noOfParticipant) * 100).toFixed(2);
      return {
        hikePercentage: percentOfAttendanceOfHike,
        stagePercentage: percentOfAttendanceOfStages
      };
    },
    getAverageCompleteRate: function getAverageCompleteRate(data) {
      var totalCompletionRate = 0;
      var noOfParticipant = data.length;
      for (var i = 0; i < data.length; i++) {
        var rate = data[i].completionPercentage.replace('%', '');
        totalCompletionRate += parseInt(rate);
      }
      return (totalCompletionRate / noOfParticipant).toFixed(2);
    }
  }
};